import { useMemo, useRef } from 'react';

import { sumCounts } from './unreadState';

// Unread counts for channels of events the user can't open. Stream's total_unread_count still
// includes them, so they are subtracted from every total Stream reports. Kept in a ref (not state)
// because the Stream listener is subscribed once and must always see the latest counts; the
// returned object is stable for the same reason.
export const useHiddenUnread = () => {
  const countsRef = useRef<Record<string, number>>({});

  return useMemo(() => ({
    clear: () => {
      countsRef.current = {};
    },
    increment: (channelId: string) => {
      countsRef.current = { ...countsRef.current, [channelId]: (countsRef.current[channelId] ?? 0) + 1 };
    },
    markRead: (channelId: string | undefined) => {
      if (channelId && channelId in countsRef.current) {
        countsRef.current = { ...countsRef.current, [channelId]: 0 };
      }
    },
    // Idempotent, so it is safe to call from a setState updater that React may run twice.
    merge: (counts: Record<string, number>) => {
      countsRef.current = { ...countsRef.current, ...counts };
    },
    remove: (channelId: string | undefined) => {
      const remaining = { ...countsRef.current };
      delete remaining[channelId as string];
      countsRef.current = remaining;
    },
    replace: (counts: Record<string, number>) => {
      countsRef.current = counts;
    },
    total: () => sumCounts(countsRef.current),
  }), []);
};
